import { ChildLinkItem, HCPNavLnk } from './HCPHeaderNavigation.types';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import { DrawerListItem, AppBarLink, AppBarProfileLink } from './HCPHeaderNavigation.style';
import { LinkField } from '@sitecore-jss/sitecore-jss-react';
import { useTheme } from '@mui/material/styles';

import { SIGN_OUT } from '../../lib/constant';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store/store';
import { useEffect, useState } from 'react';
import { scrollToSectionPath } from '../../lib/utils/common';
import { useRouter } from 'next/router';

const fallbackLink: LinkField = { value: { href: '', text: '' } };
const fallbackChildLinks = [{ fields: { link: fallbackLink } }];

export const ChildList: React.FC<{
  links: Array<ChildLinkItem>;
  handleDrawerToggle: () => void;
  openProfileModal?: any;
  fieldItem?: any;
}> = (props) => {
  const theme = useTheme();
  const router = useRouter();
  const isNotificationBannerOpen = useSelector(
    (state: RootState) => state?.config?.isNotificationBannerOpen
  );
  const [currentHash, setCurrentHash] = useState<any>('');

  const handleNavigation = (e: React.MouseEvent<HTMLLIElement, MouseEvent>, item: string) => {
    e.stopPropagation();
    props.handleDrawerToggle();
    router.push(item);
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setCurrentHash(window.location.hash);
      const handleHashChange = () => {
        setCurrentHash(window.location.hash);
      };
      window.addEventListener('hashchange', handleHashChange);
      return () => {
        window.removeEventListener('hashchange', handleHashChange);
      };
    } else {
      return;
    }
  }, []);

  useEffect(() => {
    const margin = isNotificationBannerOpen ? 100 : 0;
    scrollToSectionPath(currentHash, margin, 1000);
  }, [currentHash]);

  const onClickMenuItem = (e: any, item: any) => {
    e.preventDefault();
    if (item.name === SIGN_OUT) {
      props?.openProfileModal({
        open: false,
        profileFields: props?.fieldItem || item.fields,
        signOutOpen: true,
      });
      props.handleDrawerToggle();
      return;
    }
    try {
      if (item) {
        const anchorVal = item?.fields?.link?.value?.anchor;
        const linkURL = item?.fields?.link?.value?.href;
        const targetElement = document.getElementById(anchorVal);
        const margin = isNotificationBannerOpen ? 100 : 0;
        if (targetElement) {
          const offsetTop = targetElement.offsetTop;
          window.scroll({
            top: offsetTop - margin,
            left: 0,
            behavior: 'smooth',
          });
        } else if (anchorVal != '' && linkURL != '') {
          window.location.href = linkURL + '#' + anchorVal;
        } else {
          window.location.href = linkURL;
        }
      }
    } catch (error) {}
    props.handleDrawerToggle();
  };

  if (Array.isArray(props.links) && props.links.length > 0) {
    return (
      <List>
        {props?.links.map((item, index) => {
          return (
            <DrawerListItem
              className={'child-link-list-item'}
              key={index}
              onClick={(e) => {
                handleNavigation(e, item.fields?.link?.value.href || '');
              }}
            >
              {item.name === SIGN_OUT ? (
                <AppBarProfileLink
                  sx={{ color: theme.palette.themeColor.main }}
                  onClick={(e) => {
                    e.preventDefault();
                    props?.openProfileModal({
                      open: false,
                      profileFields: props?.fieldItem || item.fields,
                      signOutOpen: true,
                    });
                  }}
                >
                  {item.fields?.link?.value.text || ''}
                </AppBarProfileLink>
              ) : (
                <AppBarLink
                  onClick={(e) => onClickMenuItem(e, item)}
                  field={item.fields?.link || fallbackLink}
                />
              )}
            </DrawerListItem>
          );
        })}
      </List>
    );
  }
  return null;
};

export const LinkList: React.FC<{
  navigationLinks: Array<HCPNavLnk>;
  openProfileModal: any;
  isAuthenticated: boolean;
  handleDrawerToggle: () => void;
}> = (props) => {
  if (Array.isArray(props.navigationLinks) && props.navigationLinks.length > 0) {
    return (
      <List>
        {props?.navigationLinks.map((item, index) => {
          const childNavList = item.fields?.childNavList;
          const isProfileLinkAsModal = item.fields?.hasOwnProperty('myProfile');
          if (isProfileLinkAsModal) {
            if (!props.isAuthenticated) {
              return (
                <DrawerListItem key={index}>
                  <AppBarLink
                    key={index}
                    onClick={(e) => {
                      e.preventDefault();
                      props?.openProfileModal({ open: true, profileFields: item.fields });
                    }}
                    field={fallbackLink}
                  >
                    {item.fields?.link?.value.text || ''}
                  </AppBarLink>
                </DrawerListItem>
              );
            }
            if (Array.isArray(childNavList) && childNavList.length > 0) {
              return (
                <>
                  <DrawerListItem>{item.fields?.link?.value.text}</DrawerListItem>
                  <ChildList
                    links={item.fields?.childNavList || (fallbackChildLinks as ChildLinkItem[])}
                    fieldItem={item.fields}
                    openProfileModal={props?.openProfileModal}
                    handleDrawerToggle={props.handleDrawerToggle}
                  />
                </>
              );
            }
          }
          if (Array.isArray(childNavList) && childNavList.length > 0) {
            return (
              <>
                <DrawerListItem>{item.fields?.link?.value.text}</DrawerListItem>
                <ChildList
                  links={item.fields?.childNavList || (fallbackChildLinks as ChildLinkItem[])}
                  fieldItem={item.fields}
                  handleDrawerToggle={props.handleDrawerToggle}
                />
              </>
            );
          }
          return (
            <DrawerListItem key={index}>
              <AppBarLink field={item.fields?.link || fallbackLink} />
            </DrawerListItem>
          );
        })}
      </List>
    );
  }
  return null;
};

const HCPMobileDrawConent: React.FC<{
  navigationLinks: Array<HCPNavLnk>;
  openProfileModal: any;
  isAuthenticated: boolean;
  handleDrawerToggle: () => void;
}> = (props) => {
  return (
    <Box
      marginTop={'10px'}
      sx={{
        '.MuiList-root': {
          paddingTop: '0px',
          paddingBottom: '5px',
        },
      }}
    >
      <LinkList
        navigationLinks={props.navigationLinks}
        openProfileModal={props?.openProfileModal}
        isAuthenticated={props?.isAuthenticated}
        handleDrawerToggle={props.handleDrawerToggle}
      />
    </Box>
  );
};
export default HCPMobileDrawConent;
